// src/features/companies/services/companyService.ts
import apiService from '@core/api/apiService';
import { Company, CompanyListResponse } from '../types';

export const companyService = {
  getCompanies: async (params: {
    page?: number;
    per_page?: number;
    search?: string;
    [key: string]: any;
  }): Promise<CompanyListResponse> => {
    return apiService.get<CompanyListResponse>('/v1/companies', params);
  },

  getCompany: async (id: number): Promise<Company> => {
    return apiService.get<Company>(`/v1/companies/${id}`);
  },

  /** دریافت کامل شرکت: اطلاعات + شعب + اکانت‌ها */
  getCompanyDetail: async (id: string | number): Promise<{
    company: Company;
    branches: any[];
    users: any[];
  }> => {
    return apiService.get<any>(`/v1/companies/${id}`);
  },

  createCompany: async (data: Partial<Company>): Promise<Company> => {
    return apiService.post<Company>('/v1/companies/store', data);
  },

  updateCompany: async (id: string | number, data: Partial<Company>): Promise<Company> => {
    return apiService.patch<Company>(`/v1/companies/update/${id}`, data);
  },

  uploadCompanyLogo: async (file: File): Promise<{ company?: Company; logo_url?: string | null }> => {
    const formData = new FormData();
    formData.append('logo', file);
    return apiService.post<{ company?: Company; logo_url?: string | null }>('/v1/company/logo', formData);
  },

  uploadCompanyLogoAsAdmin: async (
    companyId: string | number,
    file: File,
  ): Promise<{ company?: Company; logo_url?: string | null }> => {
    const formData = new FormData();
    formData.append('logo', file);
    return apiService.post<{ company?: Company; logo_url?: string | null }>(
      `/v1/companies/${companyId}/logo`,
      formData,
    );
  },

  changeStatus: async (data: any): Promise<any> => {
    return apiService.post('/v1/companies/changeStatus', data);
  },

  /** ساخت اکانت برای شرکت (با هر نقشی) */
  createCompanyUser: async (id: string | number, data: any): Promise<any> => {
    return apiService.post(`/v1/companies/${id}/users`, data);
  },

  resetCompanyUserPassword: async (
    companyId: string | number,
    userId: string | number,
    password: string,
    passwordConfirmation: string,
  ): Promise<any> => {
    return apiService.post(`/v1/companies/${companyId}/users/${userId}/reset-password`, {
      password,
      password_confirmation: passwordConfirmation,
    });
  },

  /** ویرایش اکانت شرکت */
  updateCompanyUser: async (data: any): Promise<any> => {
    return apiService.patch('/v1/company/users/update', data);
  },

  /** تغییر وضعیت اکانت */
  changeCompanyUserStatus: async (id: string | number): Promise<any> => {
    return apiService.post('/v1/admin/users/changeStatus', { id });
  },

  /** ایجاد شعبه برای یک شرکت */
  createBranch: async (companyId: string | number, data: any): Promise<any> => {
    return apiService.post(`/v1/companies/${companyId}/branches`, data);
  },

  /** ویرایش شعبه */
  updateBranch: async (id: string | number, data: any): Promise<any> => {
    return apiService.patch(`/v1/company/branches/update/${id}`, data);
  },

  deleteCompany: async (id: number): Promise<void> => {
    return apiService.delete(`/v1/companies/${id}`);
  },
};
